import { jetSkiHighlights, jetSkiImage } from "@/mocks/homeData";
import { WHATSAPP_LINK } from "@/pages/home/constants";

export default function JetSki() {
  return (
    <section id="jet-ski" className="relative py-7 md:py-10 bg-secondary-100 scroll-mt-16 overflow-hidden">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[1500px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center">
            <div className="reveal order-2 lg:order-1">
              <span className="inline-block text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] text-primary-700 mb-3">
                Adrenalina no Mar de Minas
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-4">
                Passeio de Jet Ski em Capitólio
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
                Tem coisa melhor do que realizar aquele sonho de pilotar um jet ski? Aqui você pode. Sinta a
                liberdade de acelerar pelas águas do Lago de Furnas com passeios guiados de jet ski, aluguel
                de jet ski em Capitólio e paradas paradisíacas para viver o Mar de Minas de um jeito único.
              </p>

              <div className="space-y-3 mb-6">
                {jetSkiHighlights.map((item) => (
                  <div key={item.id} className="flex items-start gap-3">
                    <span className="w-10 h-10 rounded-full bg-accent-500/15 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-accent-600 text-xl`} />
                    </span>
                    <div>
                      <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-0.5">
                        {item.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href={WHATSAPP_LINK}
                data-whatsapp-cta
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-bold bg-accent-500 text-primary-950 hover:bg-accent-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg" />
                Quero reservar meu jet ski
              </a>
            </div>

            <div className="reveal reveal-delay-2 order-1 lg:order-2 relative w-full max-w-md lg:max-w-sm mx-auto">
              <div className="relative w-full aspect-[4/3] lg:aspect-square rounded-2xl overflow-hidden">
                <img
                  src={jetSkiImage}
                  alt="Passeio de jet ski em Capitólio no Lago de Furnas"
                  title="Eco Tour Turismo - Passeios de Jet Ski em Capitólio"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/25 to-transparent" />
              </div>
              <div className="absolute bottom-4 left-4 right-4 bg-background-50/95 backdrop-blur rounded-xl px-4 py-3 flex items-center gap-3 border border-secondary-200">
                <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                  <i className="ri-speed-up-line text-white text-lg" />
                </span>
                <div>
                  <p className="text-xs font-heading font-bold text-primary-900">Saídas diárias</p>
                  <p className="text-[11px] text-foreground-500">Consulte preços e disponibilidade</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}